import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 37,
	height: 37,
	viewBox: "17 16.999988555908203 51 63.0000114440918",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M64.8842 54.4447L26.6752 79.0102C25.7733 79.6401 24.4614 80 23.3955 80C22.3296 80 21.1817 79.6401 20.2797 79.0102C18.3119 77.8404 17 75.4108 17 72.9813V23.9403C17 21.5107 18.3119 19.1712 20.2797 17.9114C22.2476 16.6516 24.6254 16.7416 26.6752 17.9114L64.8842 42.4769C66.8521 43.6467 68 46.0762 68 48.5058C68 50.9353 66.9341 53.2749 64.8842 54.4447Z",
		fill: "white"
	})
});
export default SvgPlay;
